var __dsT = function (k, d) { var o = window.dsI18n || {}; return (o[k] != null) ? o[k] : d; };
/* De Sierkamer — header interactivity (dropdown menu, mobile menu, live cart badge). */
(function () {
  'use strict';
  if (window.__dsGlobalInit) return;
  window.__dsGlobalInit = true;

  /* Collecties dropdown (variant 1c): opent op klik, sluit bij klik buiten, Escape of tab-uit. */
  class DsNavMenu extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('button');
      if (!this.btn) return;
      this.btn.addEventListener('click', (e) => { e.preventDefault(); this.toggle(!this.classList.contains('is-open')); });
      document.addEventListener('mousedown', (e) => { if (!this.contains(e.target)) this.toggle(false); });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) { this.toggle(false); this.btn.focus(); }
      });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.toggle(false); });
    }
    toggle(open) {
      this.classList.toggle('is-open', open);
      if (this.btn) this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
  if (!customElements.get('ds-nav-menu')) customElements.define('ds-nav-menu', DsNavMenu);

  /* Mobile hamburger */
  document.addEventListener('click', function (e) {
    const burger = e.target.closest('[data-ds-burger]');
    if (burger) {
      const hdr = burger.closest('.ds-hdr');
      const open = hdr.classList.toggle('is-menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      return;
    }
    const menuClose = e.target.closest('[data-ds-menu-close]');
    if (menuClose) {
      const hdr = menuClose.closest('.ds-hdr');
      hdr.classList.remove('is-menu-open');
      document.documentElement.style.overflow = '';
      const b = hdr.querySelector('[data-ds-burger]');
      if (b) b.setAttribute('aria-expanded', 'false');
      return;
    }
    const hdr = document.querySelector('.ds-hdr.is-menu-open');
    if (hdr && !e.target.closest('.ds-hdr')) {
      hdr.classList.remove('is-menu-open');
      document.documentElement.style.overflow = '';
    }
  });

  /* Mobiel: binnen één groep blijft er maar één accordeon open staan.
     Het toggle-event bubbelt niet, dus luisteren we in de capture-fase. */
  document.addEventListener('toggle', function (e) {
    const item = e.target;
    if (!item || item.tagName !== 'DETAILS' || !item.open) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const group = item.closest('.ds-acc, .ds-ftr-m__groups');
    if (!group) return;
    group.querySelectorAll('details[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);

  /* Live cart badge: refresh after any cart mutation */
  function updateCartBadge() {
    fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ds-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () {});
  }
  const _fetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (res) { if (res.ok) setTimeout(updateCartBadge, 50); }).catch(function () {});
    }
    return p;
  };
})();

/* ---------- Recent bekeken ----------
   Dit element staat óók in ds-pages.js, maar daar worden de kaarten gebouwd uit
   /products/<handle>.js — en daar zit geen voorraadaantal in, dus geen chip en
   geen adviesprijs. Hier halen we per lamp de kaart server-side op via de
   Section Rendering API (sections/ds-recent-card.liquid), zodat dezelfde
   kortings- en voorraadregels gelden als in het collectieraster.

   ds-global.js staat vóór ds-pages.js in de pagina, dus deze definitie wint:
   ds-pages.js doet customElements.get('ds-recent') || define(...) en slaat over. */
(function () {
  'use strict';
  if (customElements.get('ds-recent')) return;

  var KEY = 'ds:recent';
  function lees() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  class DsRecent extends HTMLElement {
    connectedCallback() {
      var self = this;
      var exclude = this.getAttribute('data-exclude');
      var handles = lees().filter(function (h) { return h && h !== exclude; }).slice(0, 5);
      if (!handles.length) return;
      var grid = this.querySelector('.ds-recent__grid');
      if (!grid) return;

      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '?section_id=ds-recent-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (delen) {
        var kaarten = delen.map(function (html) {
          if (!html) return '';
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var kaart = doc.querySelector('.ds-recent__card');
            return kaart ? kaart.outerHTML : '';
          } catch (e) { return ''; }
        }).filter(Boolean);
        if (!kaarten.length) return;
        grid.innerHTML = kaarten.join('');
        self.classList.add('has-items');
      });
    }
  }
  customElements.define('ds-recent', DsRecent);
})();

/* ---------- Favorites (localStorage) ---------- */
(function () {
  'use strict';
  if (window.__dsFavsInit) return;
  window.__dsFavsInit = true;

  var FKEY = 'ds:favs';
  function readFavs() { try { return JSON.parse(localStorage.getItem(FKEY) || '[]'); } catch (e) { return []; } }
  function writeFavs(list) { try { localStorage.setItem(FKEY, JSON.stringify(list)); } catch (e) {} }

  function markFavs() {
    var favs = readFavs();
    document.querySelectorAll('[data-ds-fav]').forEach(function (btn) {
      var active = favs.indexOf(btn.getAttribute('data-ds-fav')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ds-fav-count]').forEach(function (el) {
      el.textContent = favs.length;
      if (favs.length > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }
  window.__dsFavsMark = markFavs;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-ds-fav');
    var favs = readFavs();
    var i = favs.indexOf(handle);
    if (i === -1) favs.unshift(handle);
    else favs.splice(i, 1);
    writeFavs(favs);
    markFavs();
    var grid = document.querySelector('ds-favorites-grid');
    if (grid && i !== -1 && !grid.isShared) {
      var card = btn.closest('[data-ds-fav-card]');
      if (card) card.remove();
      grid.updateEmpty();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markFavs);
  else markFavs();

  /* Favorites page grid */
  var DsFavoritesGrid = function () { return Reflect.construct(HTMLElement, [], DsFavoritesGrid); };
  DsFavoritesGrid.prototype = Object.create(HTMLElement.prototype);
  DsFavoritesGrid.prototype.constructor = DsFavoritesGrid;
  Object.setPrototypeOf(DsFavoritesGrid, HTMLElement);

  DsFavoritesGrid.prototype.connectedCallback = function () {
    var self = this;
    var shared = null;
    try {
      var p = new URLSearchParams(location.search).get('favs');
      if (p) shared = p.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 24);
    } catch (e) {}
    this.isShared = !!(shared && shared.length);
    var handles = this.isShared ? shared : readFavs();
    if (this.isShared) {
      var note = this.querySelector('[data-ds-shared-note]');
      if (note) note.removeAttribute('hidden');
    }
    this.grid = this.querySelector('.ds-favpage__grid');
    this.empty = this.querySelector('.ds-favpage__empty');
    this.countEl = this.querySelector('[data-ds-fav-total]');
    if (!handles.length) { this.updateEmpty(); return; }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var items = products.filter(Boolean);
      var money = function (cents) {
        var s = (cents / 100).toFixed(2).replace('.', ',');
        return '€' + s;
      };
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
      self.grid.innerHTML = items.map(function (p) {
        var title = esc((p.title || '').split('| ').pop().trim());
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var img2 = (p.images && p.images[1]) ? p.images[1] + (p.images[1].indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var variant = p.variants && p.variants[0];
        var cta;
        if (p.available && variant && p.variants.length === 1) {
          cta = '<add-to-cart class="ds-card__cta" role="button" tabindex="0" data-variant-id="' + variant.id + '">In winkelmandje</add-to-cart>';
        } else if (p.available) {
          cta = '<a href="/products/' + p.handle + '" class="ds-card__cta">' + __dsT("view_lamp", "Bekijk de lamp") + '</a>';
        } else {
          cta = '<button class="ds-card__cta ds-card__cta--notify" type="button" data-ds-bis="' + (variant ? variant.id : '') + '" data-ds-bis-product="' + p.id + '" data-ds-bis-title="' + title + '">' + __dsT("notify_stock", "Mail mij bij voorraad") + '</button>';
        }
        return '<div class="ds-card" data-ds-fav-card>' +
          '<a href="/products/' + p.handle + '" class="ds-card__media" tabindex="-1">' +
          (img ? '<img class="ds-card__img" src="' + img + '" alt="' + title + '" loading="lazy">' : '') +
          (img2 ? '<img class="ds-card__img ds-card__img--alt" src="' + img2 + '" alt="" loading="lazy" aria-hidden="true">' : '') +
          '<button type="button" class="ds-fav-btn" data-ds-fav="' + p.handle + '" aria-label="' + __dsT("save_fav", "Bewaar als favoriet") + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.6-7-9.4A4.1 4.1 0 0 1 12 8a4.1 4.1 0 0 1 7 2.6c0 4.8-7 9.4-7 9.4z"></path></svg></button></a>' +
          '<a href="/products/' + p.handle + '" class="ds-card__title">' + title + '</a>' +
          '<div class="ds-card__row"><span class="ds-card__price">' + money(p.price) + '</span></div>' +
          '<div class="ds-card__rating"></div>' +
          cta + '</div>';
      }).join('');
      self.updateEmpty();
      markFavs();
    });
  };
  DsFavoritesGrid.prototype.updateEmpty = function () {
    var count = this.grid ? this.grid.querySelectorAll('[data-ds-fav-card]').length : 0;
    if (this.empty) this.empty.style.display = count ? 'none' : '';
    if (this.grid) this.grid.style.display = count ? '' : 'none';
    if (this.countEl) this.countEl.textContent = count === 1 ? __dsT("one_saved", '1 lamp bewaard') : count + __dsT("n_saved_suffix", ' lampen bewaard');
  };
  if (!customElements.get('ds-favorites-grid')) customElements.define('ds-favorites-grid', DsFavoritesGrid);
})();

/* ---------- Favorites: share via WhatsApp / copy link ---------- */
(function () {
  'use strict';
  if (window.__dsShareInit) return;
  window.__dsShareInit = true;

  function shareUrl() {
    var handles = [];
    try {
      var p = new URLSearchParams(location.search).get('favs');
      if (p) handles = p.split(',').filter(Boolean);
      else handles = JSON.parse(localStorage.getItem('ds:favs') || '[]');
    } catch (e) {}
    if (!handles.length) return null;
    return location.origin + location.pathname + '?favs=' + handles.slice(0, 24).map(encodeURIComponent).join(',');
  }

  document.addEventListener('click', function (e) {
    var wa = e.target.closest('[data-ds-share-wa]');
    if (wa) {
      var url = shareUrl();
      if (!url) return;
      var text = __dsT("share_text", 'Kijk eens naar deze Tiffany lampen die ik bewaarde bij De Sierkamer: ') + url;
      window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank', 'noopener');
      return;
    }
    var cp = e.target.closest('[data-ds-share-copy]');
    if (cp) {
      var u = shareUrl();
      if (!u) return;
      var done = function () {
        var lbl = cp.querySelector('[data-ds-share-label]');
        if (lbl) {
          var orig = lbl.textContent;
          lbl.textContent = __dsT("link_copied", 'Link gekopieerd ✓');
          setTimeout(function () { lbl.textContent = orig; }, 2200);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(u).then(done).catch(function () { window.prompt(__dsT("copy_the_link", 'Kopieer de link:'), u); });
      } else {
        window.prompt(__dsT("copy_the_link", 'Kopieer de link:'), u);
      }
    }
  });

  function toggleShareRow() {
    var row = document.querySelector('[data-ds-share-row]');
    if (!row) return;
    var has = !!shareUrl();
    row.style.display = has ? '' : 'none';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', toggleShareRow);
  else toggleShareRow();
  document.addEventListener('click', function () { setTimeout(toggleShareRow, 150); });
})();

/* Terug-op-voorraad: inschrijving gaat naar de mini: waitlist-app, zodat de
   melding in het app-dashboard staat en de winkel er bericht van krijgt.

   De app werkt via de app proxy /apps/vacation:
   - POST /apps/vacation/fields/get-by-product-id/<productId>  -> haalt de
     waitlist-instelling (het "veld") op dat bij dit product hoort;
   - POST /apps/vacation/customers/create?fieldId=<veldId>     -> schrijft in.

   Op een productpagina zet de app zelf window.activeFieldId en window.fieldData;
   op een collectiepagina of de favorietenpagina bestaan die niet, dus halen we
   het veld dan zelf op aan de hand van het product-id op de knop. */
(function () {
  if (window.__dsBisInit) return;
  window.__dsBisInit = true;

  function winkelNaam() {
    return (window.Shopify && window.Shopify.shop) || window.miniVacNotifyStoreName || '';
  }

  function haalVeld(productId) {
    if (window.activeFieldId && window.fieldData && String(window.miniVacNotifyProductId || '') === String(productId)) {
      return Promise.resolve({ id: window.activeFieldId, data: window.fieldData });
    }
    return fetch('/apps/vacation/fields/get-by-product-id/' + encodeURIComponent(productId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ collections: [], shop: winkelNaam() })
    }).then(function (r) {
      if (!r.ok) throw new Error('veld ophalen mislukt: ' + r.status);
      return r.json();
    }).then(function (d) {
      var veld = d && d.fields && d.fields[0];
      if (!veld || !veld._id) throw new Error('geen waitlist-veld voor dit product');
      return { id: veld._id, data: veld.data };
    });
  }

  function meldAan(email, productId, variantId) {
    return haalVeld(productId).then(function (veld) {
      return fetch('/apps/vacation/customers/create?fieldId=' + encodeURIComponent(veld.id), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerName: '',
          email: email,
          customerPhone: '',
          shop: winkelNaam(),
          productId: String(productId),
          variantId: variantId ? Number(variantId) : null,
          consentOption: true,
          fieldData: veld.data
        })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('inschrijven mislukt: ' + r.status);
      return r;
    });
  }

  var overlay = null;
  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'ds-sec ds-bis';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="ds-bis__bg" data-ds-bis-close aria-label="' + __dsT("close", "Sluiten") + '"></button>' +
      '<div class="ds-bis__box" role="dialog" aria-modal="true" aria-label="' + __dsT("notify_stock", "Mail mij bij voorraad") + '">' +
        '<button type="button" class="ds-bis__close" data-ds-bis-close aria-label="' + __dsT("close", "Sluiten") + '">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
        '<div class="ds-bis__eyebrow">' + __dsT("sold_out", "Tijdelijk uitverkocht") + '</div>' +
        '<div class="ds-bis__title"></div>' +
        '<p class="ds-bis__text">' + __dsT("bis_text", "Laat je e-mailadres achter en we sturen je één mailtje zodra deze lamp er weer is. Geen nieuwsbrief, geen spam.") + '</p>' +
        '<form class="ds-bis__form">' +
          '<input type="email" name="email" required placeholder="' + __dsT("your_email_short", "Je e-mailadres") + '" autocomplete="email" aria-label="' + __dsT("your_email_short", "Je e-mailadres") + '">' +
          '<button type="submit">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3 7.5l9 6 9-6"></path></svg>' +
            '<span>' + __dsT("keep_posted", "Houd me op de hoogte") + '</span>' +
          '</button>' +
        '</form>' +
        '<div class="ds-bis__msg"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function closeOverlay() {
    if (overlay && !overlay.hidden) {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-bis]');
    if (btn) {
      e.preventDefault();
      var ov = ensureOverlay();
      ov.querySelector('.ds-bis__title').textContent = btn.getAttribute('data-ds-bis-title') || __dsT("this_lamp", 'Deze lamp');
      ov.dataset.variant = btn.getAttribute('data-ds-bis') || '';
      ov.dataset.product = btn.getAttribute('data-ds-bis-product') || window.miniVacNotifyProductId || '';
      var form = ov.querySelector('.ds-bis__form');
      form.hidden = false;
      var msg = ov.querySelector('.ds-bis__msg');
      msg.textContent = '';
      msg.className = 'ds-bis__msg';
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var inp = ov.querySelector('input'); if (inp) inp.focus(); }, 60);
      return;
    }
    if (e.target.closest('[data-ds-bis-close]')) closeOverlay();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ds-bis__form');
    if (!form) return;
    e.preventDefault();
    var ov = form.closest('.ds-bis');
    var email = form.querySelector('input[type="email"]').value.trim();
    var variant = ov.dataset.variant;
    var product = ov.dataset.product;
    var msg = ov.querySelector('.ds-bis__msg');
    var sub = form.querySelector('button[type="submit"]');
    var subLabel = sub.querySelector('span');
    sub.disabled = true;
    if (subLabel) subLabel.textContent = __dsT("sending", 'Versturen…');
    meldAan(email, product, variant).then(function () {
      form.hidden = true;
      msg.className = 'ds-bis__msg ds-bis__msg--ok';
      msg.textContent = __dsT("bis_ok", 'Gelukt! We sturen je één mailtje zodra deze lamp er weer is.');
    }).catch(function (err) {
      if (window.console && console.warn) console.warn('[ds] waitlist', err);
      msg.className = 'ds-bis__msg ds-bis__msg--err';
      msg.textContent = __dsT("bis_err", 'Dat lukte even niet. Mail ons op info@desierkamer.nl, dan zetten wij je op de lijst.');
    }).finally(function () {
      sub.disabled = false;
      if (subLabel) subLabel.textContent = __dsT('keep_posted', 'Houd me op de hoogte');
    });
  });
})();

/* Mailto/tel-fix: het basisthema toont bij beforeunload een dekkende laadovergang,
   maar bij een mailto:/tel:-link verlaat je de pagina nooit — haal de overlay dan weer weg. */
(function () {
  if (window.__dsMailtoFix) return;
  window.__dsMailtoFix = true;
  function clearUnloading() {
    if (document.body) document.body.classList.remove('unloading');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="mailto:"], a[href^="tel:"]');
    if (a) {
      setTimeout(clearUnloading, 300);
      setTimeout(clearUnloading, 1200);
    }
  });
  window.addEventListener('focus', clearUnloading);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) clearUnloading();
  });

  /* Jubileum-countdown — bedient elke [data-ds-jubileum] op de pagina (de balk
     boven de header en de timer onder de bestelknop). Let op: het attribuut
     heet bewust niet data-ds-countdown; dat is al in gebruik voor de
     "voor 17.00 besteld"-teller in ds-pages.js. */
  (function () {
    var pad2 = function (n) { return n < 10 ? '0' + n : String(n); };

    var timers = Array.prototype.map.call(
      document.querySelectorAll('[data-ds-jubileum]'),
      function (el) {
        return {
          el: el,
          eind: new Date(el.getAttribute('data-deadline')).getTime(),
          klok: el.querySelector('[data-cd-clock]'),
          afgelopenEl: el.querySelector('[data-cd-expired]'),
          uit: {
            days: el.querySelector('[data-cd="days"]'),
            hours: el.querySelector('[data-cd="hours"]'),
            minutes: el.querySelector('[data-cd="minutes"]'),
            seconds: el.querySelector('[data-cd="seconds"]')
          },
          // de balk in de header padt naar twee cijfers, de producttimer niet
          pad: el.classList.contains('ds-jub')
        };
      }
    );
    if (!timers.length) return;

    var iv = null;

    function afloop(t) {
      if (t.el.getAttribute('data-hide-on-expire') === 'true') {
        t.el.style.display = 'none';
        return;
      }
      if (t.klok) t.klok.style.display = 'none';
      var label = t.el.querySelector('.ds-pdp-timer__label');
      if (label) label.style.display = 'none';
      if (t.afgelopenEl) {
        t.afgelopenEl.textContent = t.el.getAttribute('data-expired') || '';
        t.afgelopenEl.hidden = false;
      }
    }

    function tik() {
      var nu = Date.now(), levend = false;

      timers.forEach(function (t) {
        if (t.klaar) return;
        if (isNaN(t.eind)) { t.klaar = true; return; }

        var over = t.eind - nu;
        if (over <= 0) { t.klaar = true; afloop(t); return; }

        var s = Math.floor(over / 1000);
        var v = {
          days: Math.floor(s / 86400),
          hours: Math.floor(s % 86400 / 3600),
          minutes: Math.floor(s % 3600 / 60),
          seconds: s % 60
        };

        for (var k in v) {
          if (!t.uit[k]) continue;
          var tekst = t.pad ? pad2(v[k]) : String(v[k]);
          if (t.uit[k].textContent !== tekst) t.uit[k].textContent = tekst;
        }
        t.el.setAttribute('data-cd-ready', '');
        levend = true;
      });

      if (!levend && iv) { clearInterval(iv); iv = null; }
    }

    tik();
    if (timers.some(function (t) { return !t.klaar; })) iv = setInterval(tik, 1000);

    // hervat direct na terugkeer uit een achtergrondtab
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tik();
    });
  })();
})();
